import React, { useState, useEffect, useRef  } from "react";
import { getDatabase, ref, get, set, remove, onValue, update, push} from "firebase/database";
import { useNavigate, useLocation } from "react-router-dom";
import app from "../../../firebaseConfig";
import Lottie from "react-lottie-player";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

import rayoazul from './assets/lottie/rayoazul.json';

import lineasblancasvolando from './assets/lottie/lineasblancasvolando.json';
import efectoparticulas from './assets/lottie/efectoparticulas.json';
import fuegorojo from './assets/lottie/fuegorojo.json';
import fuegoamarillo from './assets/lottie/fuegoamarillo.json';
import neutron from './assets/lottie/neutron.json';
import ondacircular from './assets/lottie/ondacircular.json';


import { QRCodeCanvas } from "qrcode.react"; // ✅ Importa la versión correcta
import TextField from '@mui/material/TextField';

import Modal from "react-modal";
import { Dialog } from "@mui/material";
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Button, DialogTitle, DialogContent,
  DialogActions,
} from "@mui/material";
import { Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReceiptIcon from "@mui/icons-material/Receipt";

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';


import ProteccionAdmin from "./proteccionadmin";
import PersonalDialog from "./personaldialog";
import AdminClaveDialog from "./adminclavedialog";

import { onChildAdded } from "firebase/database";


import "react-toastify/dist/ReactToastify.css";

Modal.setAppElement("#root"); // Evita problemas de accesibilidad


// Función para mezclar un array aleatoriamente (Fisher-Yates Shuffle)
const shuffleArray = (array) => {
  return array
    .map((item) => ({ item, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ item }) => item);
};


function PantallaPrincipal() {

  const [mesas, setMesas] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedMesa, setSelectedMesa] = useState(null);
  const [selectedURL, setSelectedURL] = useState("");

  const [categorias, setCategorias] = useState([]);
  const qrRef = useRef(null);
  const [animacionSeleccionada, setAnimacionSeleccionada] = useState(null);

  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [categoria, setCategoria] = useState("");
  const [linkImg, setLinkImg] = useState("");
  const [selectedCategoria, setSelectedCategoria] = useState(null);
  const db = getDatabase();

  const [codigo, setCodigo] = useState("");
  const [nuevoCodigo, setNuevoCodigo] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const codigoRef = ref(db, "nature/Awoo/Control/CodigoMesas");

  const [pedidos, setPedidos] = useState([]);
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  const [open, setOpen] = useState(false);
  
  const [servicios, setServicios] = useState({});
  const [selectedServicio, setSelectedServicio] = useState("");
  const [error, setError] = useState(""); // Estado para errores

  const [openEditDialog, setOpenEditDialog] = useState(false);
const [editCategoria, setEditCategoria] = useState("");
const [editImg, setEditImg] = useState("");

const [datosEmpresa, setDatosEmpresa] = useState({});
const [numeroFactura, setNumeroFactura] = useState(1);
const location = useLocation();
const [pedidoEditable, setPedidoEditable] = useState(null);

const [clientes, setClientes] = useState([]);
const [limiteVisitas, setLimiteVisitas] = useState(3);
const [clientesFiltrados, setClientesFiltrados] = useState([]);
const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
const [openDialog, setOpenDialog] = useState(false);

const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);

  const [adminVerified, setAdminVerified] = useState(false);
  const [claves, setClaves] = useState({
    Pedidos: "",
    Cocina: "",
    Bar: "",
  });
  const [originalClaves, setOriginalClaves] = useState({});
  const [loading, setLoading] = useState(true);

  const [mostrarLinks, setMostrarLinks] = useState(false);
  const [links, setLinks] = useState({});

  const [empleadosDisponibles, setEmpleadosDisponibles] = useState([]);

  const [dialogOpen, setDialogOpen] = useState(false);
const [adminVerificado, setAdminVerificado] = useState(false);


const navigate = useNavigate(); // Hook para navegar entre páginas


//----------------------------- Codigo para Generar Orden
  // ---- RENOMBRADOS para evitar conflictos ----
  const [openOrden, setOpenOrden] = useState(false);
  const [categoriaOrden, setCategoriaOrden] = useState("");
  const [categoriasOrden, setCategoriasOrden] = useState([]);
  // -------------------------------------------

  const [productoOrden, setProductoOrden] = useState("");
  const [productosOrden, setProductosOrden] = useState([]);
  const [mostrarProductosOrden, setMostrarProductosOrden] = useState(false);
  const [descripcionOrden, setDescripcionOrden] = useState("");
  const [precioUndOrden, setPrecioUndOrden] = useState("");
  const [cantidadOrden, setCantidadOrden] = useState("");
  const [costoUndOrden, setCostoUndOrden] = useState("");
  const [precioTotalOrden, setPrecioTotalOrden] = useState("");
  const [costoTotalOrden, setCostoTotalOrden] = useState("");
  const [gananciaTotalOrden, setGananciaTotalOrden] = useState("");

  const handleOpen = () => setOpenOrden(true);
  const handleCloseOrden = () => setOpenOrden(false);
//--------------------------------------

  // ✅ Cargar categorías desde Firebase (usa las variables renombradas)
  useEffect(() => {
    const categoriasRef = ref(db, "nature/Awoo/Categorias");
    onValue(categoriasRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setCategoriasOrden(Object.keys(data));
      } else {
        setCategoriasOrden([]);
      }
    });
  }, [db]);

  // ✅ Cargar productos según categoría
  const cargarProductosOrden = () => {
    if (!categoriaOrden) {
      alert("Selecciona una categoría primero");
      return;
    }
    const productosRef = ref(db, `nature/Awoo/Categorias/${categoriaOrden}`);
    onValue(productosRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setProductosOrden(Object.keys(data));
        setMostrarProductosOrden(true);
      } else {
        setProductosOrden([]);
        setMostrarProductosOrden(true);
      }
    });
  };
  
  // ✅ Calcular totales
  const calcularTotalesOrden = () => {
    const p = parseFloat(precioUndOrden) || 0;
    const c = parseFloat(cantidadOrden) || 0;
    const cu = parseFloat(costoUndOrden) || 0;
    const precioT = p * c;
    const costoT = cu * c;
    const ganancia = precioT - costoT;
    setPrecioTotalOrden(precioT.toFixed(2));
    setCostoTotalOrden(costoT.toFixed(2));
    setGananciaTotalOrden(ganancia.toFixed(2));
  };

  useEffect(() => {
    calcularTotalesOrden();
  }, [precioUndOrden, cantidadOrden, costoUndOrden]);
  
    useEffect(() => {
      calcularTotalesOrden();
    }, [precioUndOrden, cantidadOrden, costoUndOrden]);
  
// ✅ Guardar orden en Firebase
const handleGuardarOrden = async () => {
  if (
    !categoriaOrden ||
    !productoOrden ||
    !precioUndOrden ||
    !cantidadOrden ||
    !costoUndOrden
  ) {
    alert("Por favor completa todos los campos obligatorios.");
    return;
  }

  const nuevaOrden = {
    categoria: categoriaOrden,
    producto: productoOrden,
    descripcion: descripcionOrden || "",
    precioUnd: parseFloat(precioUndOrden),
    cantidad: parseFloat(cantidadOrden),
    costoUnd: parseFloat(costoUndOrden),
    precioTotal: parseFloat(precioTotalOrden),
    costoTotal: parseFloat(costoTotalOrden),
    gananciaTotal: parseFloat(gananciaTotalOrden),
    estado: "Preparando",
    fecha: new Date().toLocaleString(),
  };

  try {
    const ordenRef = push(ref(db, "nature/Awoo/Ordenes"));
    await set(ordenRef, nuevaOrden);
    alert("✅ Orden guardada correctamente en Firebase");
    
    // ✅ Limpiar los campos
    setCategoriaOrden("");
    setProductoOrden("");
    setPrecioUndOrden("");
    setCantidadOrden("");
    setCostoUndOrden("");

    handleCloseOrden();
  } catch (error) {
    console.error("Error al guardar la orden:", error);
    alert("❌ Error al guardar la orden");
  }
};
///------------------------------------------------------------------------------------


  // Arreglo de animaciones disponibles
const animacionesDisponibles = [
  lineasblancasvolando,
  efectoparticulas,
  fuegoamarillo,
  rayoazul,
  rayoazul,
  rayoazul,
  rayoazul,
  rayoazul,
  neutron,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  fuegorojo,
  fuegoamarillo,
];

  const [mostrarAnimacion, setMostrarAnimacion] = useState(true);
  const [modoEditarMesero, setModoEditarMesero] = useState(false);
  const [nuevoMesero, setNuevoMesero] = useState(pedidoSeleccionado?.empleado || '');

  // Estado para los meseros
const [meseros, setMeseros] = useState([]);


////////////////// ENVIAR PEDIDOS SOLICITADOS A TELEGRAM y VALIDA CONDICIONAL DE MESERO AUTOMATICO CUANDO ES UNO
useEffect(() => {
  const db = getDatabase(app);
  const pedidosRef = ref(db, "nature/Awoo/Pedidos/Solicitados");

  const unsubscribe = onChildAdded(pedidosRef, async (snapshot) => {
    const pedido = snapshot.val();
    const pedidoId = snapshot.key;
    if (!pedido) return;

    // Si hay un solo mesero y el pedido no tiene asignado
    if (pedido.empleado === "No Asignado" && meseros.length === 1) {
      const meseroUnico = meseros[0];

      const updates = {};
      updates[`nature/Awoo/Pedidos/Solicitados/${pedidoId}/empleado`] = meseroUnico;

      try {
        await update(ref(db), updates);

        // Actualiza el pedido local para enviarlo con el mesero correcto
        pedido.empleado = meseroUnico;
        console.log("✅ Mesero único asignado antes de enviar a Telegram");
      } catch (error) {
        console.error("❌ Error asignando mesero único antes del Telegram:", error);
      }
    }

    const mensaje = formatearMensajeTelegram(pedido);
    enviarMensajeTelegram(mensaje);
  });

  return () => unsubscribe();
}, [meseros]);

////////////
////////////
////////////

/////////////////// Escuchar a Firebase cuando se monte el componente
useEffect(() => {
  const personalRef = ref(db, "nature/Awoo/Control/Personal");
  const unsubscribe = onValue(personalRef, (snapshot) => {
    if (snapshot.exists()) {
      const data = snapshot.val();
      const nombres = Object.values(data)
        .map((item) => item.nombre)
        .filter(Boolean); // Evita nulos o vacíos
      setMeseros(nombres);
    }
  });

  return () => unsubscribe(); // Limpieza del listener al desmontar
}, []);


///////////////ASIGNACIÓN DE MESERO
const guardarNuevoMesero = (nuevoValor) => {
  if (!pedidoSeleccionado?.id) return;
  const updates = {};
  updates[`nature/Awoo/Pedidos/Solicitados/${pedidoSeleccionado.id}/empleado`] = nuevoValor;
  update(ref(db), updates)
    .then(() => {
      setModoEditarMesero(false);
      setPedidoSeleccionado(prev => ({ ...prev, empleado: nuevoValor }));
    })
    .catch(error => {
      console.error("Error al actualizar mesero:", error);
    });
};




/////////////////////// CODIGO PARA BOTONES INICIALES
  useEffect(() => {
    if (showDialog && adminVerified) {
      const loadClaves = () => {
        const paths = {
          Pedidos: "nature/Awoo/Control/Seguridad/Pedidos",
          Cocina: "nature/Awoo/Control/Seguridad/Servicios/Cocina",
          Bar: "nature/Awoo/Control/Seguridad/Servicios/Barra",
          Admin: "nature/Awoo/Control/Seguridad/Admin", // nuevo
        };

        const updates = {};
        let count = 0;

        Object.entries(paths).forEach(([key, path]) => {
          onValue(ref(db, path), (snap) => {
            updates[key] = snap.val() || "";
            count++;
            if (count === Object.keys(paths).length) {
              setClaves(updates);
              setOriginalClaves(updates);
              setLoading(false);
            }
          });
        });
      };

      loadClaves();
    }
  }, [showDialog, adminVerified]);

/////////////CODIGO PARA PREMIAR CLIENTES
useEffect(() => {
  const db = getDatabase(app);
  const controlRef = ref(db, "nature/Awoo/Control/PremiarVisitas");

  onValue(controlRef, (snapshot) => {
    const valor = snapshot.val();
    if (valor) setLimiteVisitas(valor);
  });
}, []);

useEffect(() => {
  const db = getDatabase(app);
  const pedidosRef = ref(db, "nature/Awoo/Pedidos/Pagados");

  onValue(pedidosRef, (snapshot) => {
    const data = snapshot.val();
    const resumen = {};

    if (data) {
      Object.entries(data).forEach(([id, pedido]) => {
        const correo = pedido.correo?.toLowerCase() || "Sin correo";
        const total = typeof pedido.totalPedido === "string"
          ? parseFloat(pedido.totalPedido.replace(/\./g, "")) || 0
          : (pedido.totalPedido || 0);

        if (!resumen[correo]) {
          resumen[correo] = {
            correo,
            visitas: 0,
            totalGastado: 0,
            pedidos: [],
          };
        }

        resumen[correo].visitas += 1;
        resumen[correo].totalGastado += total;
        resumen[correo].pedidos.push({
          ...pedido,
          totalPedido: total,
        });
      });

      const filtrados = Object.values(resumen).filter(
        (cliente) => cliente.visitas >= limiteVisitas && cliente.correo !== "no proporcionado"
      );

      setClientesFiltrados(filtrados);
    }
  });
}, [limiteVisitas]);

 //////////////////////////////////////////////////
 //////////////////////////////////////////////////
useEffect(() => {
  if (pedidoSeleccionado) {
    setPedidoEditable(JSON.parse(JSON.stringify(pedidoSeleccionado))); // Clon profundo
  }
}, [pedidoSeleccionado]);

////////////////////
//////////////mesas/////////////////////////////////////////////////
  useEffect(() => {
    const fetchMesas = async () => {
      const db = getDatabase();
      const mesasRef = ref(db, "nature/Awoo/Mesas");

      try {
        const snapshot = await get(mesasRef);
        if (snapshot.exists()) {
          const mesasArray = Object.entries(snapshot.val()).map(([key, value]) => ({
            numero: Number(key),
            url: value, // Obtiene la URL desde Firebase
          }));
          setMesas(mesasArray);
        }
      } catch (error) {
        console.error("Error al obtener mesas:", error);
      }
    };

    fetchMesas();
  }, []);
  /////////////////////////
  //CODIGO DE MESAS SEGURIDAD QR PEDIDOS
  useEffect(() => {
    get(codigoRef).then((snapshot) => {
      if (snapshot.exists()) {
        setCodigo(snapshot.val());
      }
    });
  }, []);
  ////////////////

///////////SERVICIOS CONTROL
useEffect(() => {
  const fetchServicios = async () => {
    try {
      const serviciosRef = ref(db, "nature/Awoo/Control/Servicios");
      const snapshot = await get(serviciosRef);
      if (snapshot.exists()) {
        const data = snapshot.val();
        console.log("Datos obtenidos de Firebase:", data); // Ver qué devuelve

        if (typeof data === "object" && data !== null) {
          setServicios(Object.keys(data)); // Convertimos las claves en un array
        } else {
          setServicios([]); // Si no es un objeto válido, dejamos vacío
        }
      } else {
        console.log("No se encontraron servicios.");
        setServicios([]);
      }
    } catch (error) {
      console.error("Error al obtener servicios:", error);
      setServicios([]);
    }
  };
  fetchServicios();
}, [db]);


////////////////////////////////////
  // Selecciona una animación aleatoria al montar el componente
  useEffect(() => {
    const seleccionAleatoria =
      animacionesDisponibles[
        Math.floor(Math.random() * animacionesDisponibles.length)
      ];
    setAnimacionSeleccionada(seleccionAleatoria);
  }, []);

//////////////////////// Aqui se obtienen las categorias

useEffect(() => {
  const db = getDatabase(app);
  const categoriasRef = ref(db, "nature/Awoo/Categorias");

  get(categoriasRef).then((snapshot) => {
    if (snapshot.exists()) {
      const categoriasData = snapshot.val();
      const categoriasArray = Object.keys(categoriasData);

      // Obtener imágenes y visibilidad para cada categoría
      Promise.all(
        categoriasArray.map(async (categoria) => {
          const imgSnapshot = await get(ref(db, `nature/Awoo/Img/${categoria}`));
          const imgUrl = imgSnapshot.exists() ? imgSnapshot.val() : "";

          const visibilidadSnapshot = await get(ref(db, `nature/Awoo/Control/Visible/Categorias/${categoria}`));
          let visibleEstado = visibilidadSnapshot.exists() ? visibilidadSnapshot.val().trim().toLowerCase() : "no";

          return { 
            nombre: categoria, 
            img: imgUrl, 
            visible: visibleEstado === "si" ? "ver.jpg" : "ocultar.jpg" 
          };
        })
      ).then((data) => setCategorias(shuffleArray(data))); // Mezclamos antes de actualizar el estado
    }
  });
}, []);

///////////////// Aqui se obtienen los pedidos ordenados
///////////////// Aqui se obtienen las ORDENES (adaptado)
useEffect(() => {
  const db = getDatabase(app);

  const ordenesRef = ref(db, "nature/Awoo/Ordenes");
  const pagosRef = ref(db, "nature/Awoo/PagosRealizados");

  // --- Listener ORDENES ---
  const unsubOrdenes = onValue(ordenesRef, (snapshot) => {
    if (snapshot.exists()) {
      const data = snapshot.val();
      console.log("ORDENES:", data);

      const ordenesArray = Object.keys(data).map((key) => ({
        id: key,
        tipo: "orden",
        ...data[key],
      }));

      setPedidos((prev) => {
        const sinPagos = prev.filter((p) => p.tipo !== "orden");
        return [...sinPagos, ...ordenesArray];
      });
    }
  });

  // --- Listener PAGOS ---
  const unsubPagos = onValue(pagosRef, (snapshot) => {
    if (snapshot.exists()) {
      const data = snapshot.val();
      console.log("PAGOS:", data);

      const pagosArray = Object.keys(data).map((key) => {
        const pago = data[key]; // YA no existe pago.Descripción
        return {
          id: key,
          tipo: "pago",
          fecha: pago.createdAt || "",
          precioTotal: pago.amount || 0,
          productos: pago.productos || [],
          nombre: pago.nombre || "",
          email: pago.email || "",
          telefono: pago.telefono || "",
          ciudad: pago.ciudad || "",
          departamento: pago.departamento || "",
        };
      });

      setPedidos((prev) => {
        const sinPagos = prev.filter((p) => p.tipo !== "pago");
        return [...sinPagos, ...pagosArray];
      });
    }
  });

  return () => {
    unsubOrdenes();
    unsubPagos();
  };
}, []);




/* Helpers para eliminar / confirmar (si ya tienes los tuyos, ignora o integra) */
const eliminarOrden = async (id) => {
  try {
    const db = getDatabase(app);
    await remove(ref(db, `nature/Awoo/Ordenes/${id}`));
    console.log("Orden eliminada:", id);
  } catch (error) {
    console.error("Error eliminando orden:", error);
  }
};

const confirmarOrden = async (orden) => {
  try {
    const db = getDatabase(app);
    // ejemplo: al confirmar cambiamos estado a "Confirmado"
    const updates = {};
    updates[`nature/Awoo/Ordenes/${orden.id}/estado`] = "Confirmado";
    await update(ref(db), updates);
    console.log("Orden confirmada:", orden.id);
  } catch (error) {
    console.error("Error confirmando orden:", error);
  }
};

//////////////

useEffect(() => {
  const db = getDatabase(app);

  // 🔹 Obtener datos de la empresa
  const facturaRef = ref(db, "nature/Awoo/Factura/Datos");
  get(facturaRef).then((snapshot) => {
    if (snapshot.exists()) {
      setDatosEmpresa(snapshot.val());
    } else {
      console.error("No se encontraron datos de la empresa.");
    }
  });

  // 🔹 Obtener número de factura (cantidad de pedidos en "Pagados" + 1)
  const pedidosRef = ref(db, "nature/Awoo/Pedidos/Pagados");
  get(pedidosRef).then((snapshot) => {
    if (snapshot.exists()) {
      setNumeroFactura(snapshot.size + 1); // 🔥 Contamos los pedidos y sumamos 1
    } else {
      setNumeroFactura(1); // Si no hay pedidos, la factura empieza en 1
    }
  });
}, []);




///////////CODIGO PARA ENVIAR PEDIDO SOLICITADO A TELEGRAM
const formatearMensajeTelegram = (pedido) => {
  const {
    correo = "No proporcionado",
    empleado = "Desconocido",
    fecha,
    hora,
    mesa,
    nota = "",
    titular,
    totalPedido,
    productos = {}
  } = pedido;

  let texto = `🧾 *Nuevo Pedido Recibido*\n\n`;
  texto += `👤 *Cliente:* ${titular || "Sin nombre"}\n`;
  texto += `📧 *Correo:* ${correo}\n`;
  texto += `🍽️ *Mesa:* ${mesa}\n`;
  texto += `👨‍🍳 *Empleado:* ${empleado}\n`;
  texto += `📅 *Fecha:* ${fecha} ${hora}\n`;
  texto += `🗒️ *Nota:* ${nota}\n\n`;

  Object.values(productos).forEach(prod => {
    texto += `• ${prod.titulo} x${prod.cantidad} = $${prod.total.toLocaleString("es-CO")}\n`;
  });

  texto += `\n💰 *Total:* $${totalPedido.toLocaleString("es-CO")}`;

  return texto;
};
// ✅ Función para obtener los datos de Telegram y enviar el mensaje
const enviarMensajeTelegram = async (mensaje) => {
  const db = getDatabase(app);
  const tokenRef = ref(db, "nature/Awoo/Control/Telegram/token");
  const idRef = ref(db, "nature/Awoo/Control/Telegram/id");

  try {
    const [tokenSnap, idSnap] = await Promise.all([get(tokenRef), get(idRef)]);

    if (tokenSnap.exists() && idSnap.exists()) {
      const BOT_TOKEN = tokenSnap.val();
      const CHAT_ID = idSnap.val();

      fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          chat_id: CHAT_ID,
          text: mensaje,
          parse_mode: "Markdown"
        })
      })
        .then(res => res.json())
        .then(data => {
          if (!data.ok) {
            console.error("❌ Error al enviar mensaje:", data);
          }
        })
        .catch(err => console.error("❌ Error en fetch:", err));
    } else {
      console.error("❌ No se encontraron token o ID en Firebase.");
    }
  } catch (error) {
    console.error("❌ Error obteniendo datos de Telegram desde Firebase:", error);
  }
};



///////////////CODIGO PREMIAR CLIENTES
const premiarCliente = async (cliente) => {
  const db = getDatabase(app);
  const pedidosRef = ref(db, "nature/Awoo/Pedidos/Pagados");

  onValue(
    pedidosRef,
    (snapshot) => {
      if (snapshot.exists()) {
        const updates = {};
        snapshot.forEach((childSnapshot) => {
          const pedido = childSnapshot.val();
          const key = childSnapshot.key;

          if (pedido.correo === cliente.correo) {
            updates[`nature/Awoo/Pedidos/Pagados/${key}/correo`] = "no proporcionado";
          }
        });

        if (Object.keys(updates).length > 0) {
          update(ref(db), updates)
            .then(() => {
              alert("✅ Cliente premiado y visitas reiniciadas");
              setOpenDialog(false); // 👈 Cerrar el dialog aquí
            })
            .catch((error) => {
              console.error("❌ Error al premiar cliente:", error);
              alert("❌ Ocurrió un error al premiar al cliente");
            });
        } else {
          alert("ℹ️ No se encontraron pedidos para actualizar");
        }
      }
    },
    { onlyOnce: true }
  );
};
const formatearFecha = (valor) => {
  if (!valor) return "";

  // Si viene como string, conviértelo
  const timestamp = Number(valor);

  // Verificar si es realmente un número válido
  if (isNaN(timestamp)) return valor;

  const fechaObj = new Date(timestamp);

  const dia = String(fechaObj.getDate()).padStart(2, "0");
  const mes = String(fechaObj.getMonth() + 1).padStart(2, "0");
  const año = fechaObj.getFullYear();

  const horas = String(fechaObj.getHours()).padStart(2, "0");
  const mins = String(fechaObj.getMinutes()).padStart(2, "0");

  return `${dia}/${mes}/${año} ${horas}:${mins}`;
};
////////////////
const descargarFactura = () => {
  if (!pedidoSeleccionado) return;

// 🔹 Productos con seguro: si no existe "productos", crear uno basado en la orden manual
let productos = [];

if (Array.isArray(pedidoSeleccionado.productos)) {
  productos = pedidoSeleccionado.productos;
} else {
  // 🔥 ORDEN MANUAL → convertirla en un producto válido
  productos = [
    {
      nombre: pedidoSeleccionado.producto || "Producto manual",
      cantidad: pedidoSeleccionado.cantidad || 1,
      precioUnitario:
        pedidoSeleccionado.precioUnd ||
        pedidoSeleccionado.precioUnitario ||
        0,
    },
  ];
}


  const pdf = new jsPDF({ unit: "mm", format: [58, 175] });
  let pageWidth = pdf.internal.pageSize.getWidth();
  let y = 8;

  const centerText = (text, yPosition, fontSize = 8) => {
    pdf.setFontSize(fontSize);
    let textWidth = pdf.getTextWidth(text);
    pdf.text(text, (pageWidth - textWidth) / 2, yPosition);
  };

  // 🔹 Datos empresa
  const {
    Empresa = "Sin Nombre",
    Descripción = "",
    Dirección = "Sin Dirección",
    Celular = "Sin Celular",
  } = datosEmpresa;

  // ENCABEZADO
  pdf.setFont("helvetica", "bold");
  centerText(Empresa, y, 11);
  y += 4;

  pdf.setFont("helvetica", "normal");
  centerText(Descripción, y, 7);
  y += 3;
  centerText(Dirección, y, 7);
  y += 3;
  centerText(`Cel: ${Celular}`, y, 7);
  y += 2;

  pdf.line(5, y, 53, y);
  y += 3;

  // FACTURA #
  pdf.setFont("helvetica", "bold");
  centerText(
    `Factura Venta N° ${numeroFactura.toString().padStart(5, "0")}`,
    y,
    8
  );
  y += 3;

  pdf.line(5, y, 53, y);
  y += 3;

  // FECHA + HORA
  const fechaFormateada = formatearFecha(pedidoSeleccionado.fecha);
  centerText(`Fecha: ${fechaFormateada}`, y, 7);
  y += 3;

  pdf.line(5, y, 53, y);
  y += 3;

  // MESA / SERVICIO + CLIENTE
  const esNumero = !isNaN(pedidoSeleccionado.mesa);
  const etiquetaMesa = esNumero ? "Email" : "Email";

  const mesaCliente = `Cliente: ${pedidoSeleccionado.nombre || ""}  |  ${etiquetaMesa}: ${pedidoSeleccionado.email || ""}`;
  centerText(mesaCliente, y, 7);
  y += 3;

  // Mesero
  if (esNumero) {
    pdf.setFont("helvetica", "bold");
    pdf.text("Mesero:", 5, y);
    pdf.setFont("helvetica", "normal");
    pdf.text(`${pedidoSeleccionado.empleado || ""}`, 20, y);
    y += 3;
  }

  pdf.line(5, y, 53, y);
  y += 3;

  // LISTA DE PRODUCTOS — AHORA SEGURA
  if (productos.length === 0) {
    centerText("(No hay productos en el pedido)", y, 7);
    y += 6;
  } else {
    pdf.setFont("helvetica", "bold");
    pdf.text("Producto", 5, y);
    pdf.text("Total", 40, y);
    y += 2;

    pdf.line(5, y, 53, y);
    y += 3;

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7);

    productos.forEach((producto) => {
      const nombre = producto.titulo || producto.nombre || "Producto";
      const precioUnitario = producto.precioUnitario || producto.preciound || 0;
      const cantidad = producto.cantidad || 1;
      const totalProducto = precioUnitario * cantidad;

      const lineasNombre = pdf.splitTextToSize(`${nombre} x${cantidad}`, 32);

      lineasNombre.forEach((linea) => {
        pdf.text(linea, 5, y);
        y += 3;
      });

      pdf.text(`$${totalProducto.toLocaleString("es-CO")}`, 40, y - 3);

      y += 1;
    });
  }

  pdf.line(5, y, 53, y);
  y += 3;

  // TOTAL GENERAL — TAMBIÉN ESTÁ SEGURO
  const totalFactura = productos.reduce((acc, p) => {
    const cant = p.cantidad || 0;
    const precio = p.precioUnitario || p.preciound || 0;
    return acc + cant * precio;
  }, 0);

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(8);
  pdf.text("Total:", 5, y);
  pdf.text(`$${totalFactura.toLocaleString("es-CO")}`, 40, y);
  y += 4;

  pdf.line(5, y, 53, y);
  y += 3;

  // PIE
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(6);

  const textoResolucion =
    "FACTURACIÓN ELECTRÓNICA SEGÚN RESOLUCIÓN DIAN No.18763003159636. Esta factura se asimila legalmente a una letra de cambio (Art. 774 C.C).";

  const lineasRes = pdf.splitTextToSize(textoResolucion, 48);
  lineasRes.forEach((linea) => {
    centerText(linea, y, 6);
    y += 2;
  });

  pdf.save(`Factura_${pedidoSeleccionado?.mesa || "Compra"}.pdf`);
};




//////////////////LINKS 
const obtenerLinks = () => {
  const db = getDatabase(app);
  const linksRef = ref(db, "nature/Awoo/Control/Links");

  onValue(linksRef, (snapshot) => {
    const data = snapshot.val();
    if (data) setLinks(data);
    else setLinks({});
  });

  setMostrarLinks(true);
};
const copiarAlPortapapeles = (texto) => {
  navigator.clipboard.writeText(texto);
  alert("✅ Link copiado al portapapeles");
};
///////////////////////
  //CODIGO DE MESAS SEGURIDAD QR PEDIDOS
  const actualizarCodigo = () => {
    set(codigoRef, nuevoCodigo.trim()) // Permitir espacio vacío
      .then(() => setCodigo(nuevoCodigo))
      .catch((error) => console.error("Error al actualizar el código", error));
    setShowDialog(false);
  };
////////////////////////////////

  // Agregar una nueva categoría
  const handleAddCategoria = async () => {

        // **Validaciones antes de guardar**
        if (!categoria.trim()) {
          alert("❌ El nombre de la categoría no puede estar vacío.");
          return;
        }
        if (!linkImg.trim()) {
          alert("❌ Debes ingresar una URL válida para la imagen.");
          return;
        }
        if (!selectedServicio) {
          alert("❌ Debes seleccionar al menos un servicio.");
          return;
        }

    if (!categoria || !linkImg || !selectedServicio) return;
    await set(ref(db, `nature/Awoo/Categorias/${categoria}`), "");
    await set(ref(db, `nature/Awoo/Img/${categoria}`), linkImg);
    await set(ref(db, `nature/Awoo/Control/Visible/Categorias/${categoria}`), "si");
    await set(ref(db, `nature/Awoo/Control/Servicios/${selectedServicio}/${categoria}`), "");
    
    setOpenAddDialog(false);
    setCategoria("");
    setLinkImg("");
    setSelectedServicio("");
    window.location.reload(); // Recargar para reflejar cambios
  };

  // Eliminar categoría y sus datos asociados
  const handleDeleteCategoria = async () => {
    if (!selectedCategoria) return;
  
    try {
      // Obtener todos los servicios
      const serviciosRef = ref(db, "nature/Awoo/Control/Servicios");
      const snapshot = await get(serviciosRef);
  
      if (snapshot.exists()) {
        const serviciosData = snapshot.val();
        console.log("Servicios encontrados:", serviciosData); // Ver qué datos trae
  
        // Iterar sobre los servicios y eliminar la categoría si existe
        for (const servicio in serviciosData) {
          if (serviciosData[servicio] && serviciosData[servicio][selectedCategoria] !== undefined) {
            console.log(`Eliminando ${selectedCategoria} de ${servicio}`);
            await remove(ref(db, `nature/Awoo/Control/Servicios/${servicio}/${selectedCategoria}`));
          }
        }
      } else {
        console.log("No se encontraron servicios en la base de datos.");
      }
  
      // Eliminar la categoría en las demás rutas
      await remove(ref(db, `nature/Awoo/Categorias/${selectedCategoria}`));
      await remove(ref(db, `nature/Awoo/Img/${selectedCategoria}`));
      await remove(ref(db, `nature/Awoo/Control/Visible/Categorias/${selectedCategoria}`));
  
      // Cerrar el diálogo y limpiar el estado
      setOpenDeleteDialog(false);
      setSelectedCategoria(null);
      window.location.reload();
    } catch (error) {
      console.error("Error al eliminar la categoría:", error);
    }
  };
  
//////////////
/////////////
const eliminarPedido = async (pedidoId) => {
  const db = getDatabase();
  const pedidoRef = ref(db, `nature/Awoo/Ordenes/${pedidoId}`);

  if (window.confirm("¿Seguro que deseas eliminar este pedido?")) {
    try {
      await remove(pedidoRef);
      console.log(`Pedido ${pedidoId} eliminado correctamente.`);
    } catch (error) {
      console.error("Error eliminando el pedido:", error);
    }
  }
};

const confirmarPedido = async (orden) => {
  const db = getDatabase();

  if (!window.confirm("¿Seguro que deseas confirmar esta orden?")) return;

  try {
    // 🔹 La orden debe tener su idPush original
    const ordenId = orden.id;
    if (!ordenId) {
      console.error("❌ No se encontró el ID del push de la orden.");
      return;
    }

    const ordenRef = ref(db, `nature/Awoo/Ordenes/${ordenId}`);
    const ordenPagadaRef = push(ref(db, "nature/Awoo/OrdenesPagadas"));

    // 🔄 Duplicar la orden en 'OrdenesPagadas'
    await set(ordenPagadaRef, {
      ...orden,
      Estado: "Pagada",
      fechaConfirmacion: new Date().toLocaleString(),
    });

    // 🗑️ Eliminar de 'Ordenes'
    await remove(ordenRef);

    console.log(`✅ Orden ${ordenId} movida a 'OrdenesPagadas' y eliminada de 'Ordenes'`);
    alert("✅ Orden confirmada y movida correctamente a OrdenesPagadas");
  } catch (error) {
    console.error("❌ Error al confirmar la orden:", error);
    alert("⚠️ Error al confirmar la orden, revisa la consola para más detalles.");
  }
};





////////////////////
/////////////////////

const handleCategoriaClick = (categoria) => {
  navigate("/awooproductos", { state: { categoria  } }); // Navegar con estado
};

////
const irclientesrecurrentes = () => {
  navigate("/awooclientesrecurrentes", {  }); // Navegar con estado
};

/////////////////////

  // Abre el modal al hacer clic en una mesa
  const openModal = (mesa) => {
    setSelectedMesa(mesa.numero);
    setSelectedURL(mesa.url);
    setModalIsOpen(true);
  };


////////////////////////
  const descargarQR = () => {
    const canvas = qrRef.current.querySelector("canvas");
    if (canvas) {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `QR_Mesa_${selectedMesa}.png`;
      link.click();
    }
  };

////////////////////////
  if (!animacionSeleccionada) return null; // Muestra nada mientras se selecciona la animación
////////////////////////////////////////////////////////////////////////////////////


const agregarMesa = async () => {
  const db = getDatabase();
  const mesasRef = ref(db, "nature/Awoo/Mesas");

  try {
    const snapshot = await get(mesasRef);
    const mesasData = snapshot.exists() ? snapshot.val() : {};
    
    // Obtener el número de la nueva mesa
    const nuevoNumero = Object.keys(mesasData).length + 1;

    // Crear la nueva mesa en Firebase
    await set(ref(db, `nature/Awoo/Mesas/${nuevoNumero}`), 
      `http://localhost:3000/awooiniciousuarios?mesa=${nuevoNumero}`
    );

    alert(`Mesa ${nuevoNumero} creada correctamente.`);
    window.location.reload(); // Recarga la página para reflejar los cambios
  } catch (error) {
    console.error("Error al agregar mesa:", error);
  }
};


const eliminarMesa = async () => {
  const db = getDatabase();
  const mesasRef = ref(db, "nature/Awoo/Mesas");

  try {
    const snapshot = await get(mesasRef);
    if (!snapshot.exists()) {
      alert("No hay mesas para eliminar.");
      return;
    }

    const mesasData = snapshot.val();
    const keys = Object.keys(mesasData);
    const ultimaMesa = Math.max(...keys.map(Number)); // Obtener el último número de mesa

    await remove(ref(db, `nature/Awoo/Mesas/${ultimaMesa}`));
    alert(`Mesa ${ultimaMesa} eliminada correctamente.`);
    window.location.reload(); // Recarga la página para reflejar los cambios
  } catch (error) {
    console.error("Error al eliminar mesa:", error);
  }
};


  // 🔹 Cambiar visibilidad de la categoría
  const toggleVisibility = async (categoria) => {
    const db = getDatabase();
    const visibleRef = ref(db, `nature/Awoo/Control/Visible/Categorias/${categoria}`);

    get(visibleRef).then((snapshot) => {
      if (snapshot.exists()) {
        let estadoActual = snapshot.val().toLowerCase();
        let nuevoEstado = estadoActual === "si" ? "no" : "si";
        set(visibleRef, nuevoEstado);

        // Cambia la imagen según el nuevo estado
        setCategorias((prevCategorias) =>
          prevCategorias.map((cat) =>
            cat.nombre === categoria
              ? { ...cat, visible: nuevoEstado === "si" ? "ver.jpg" : "ocultar.jpg" }
              : cat
          )
        );
      }
    });
  };
//////////////////////////////
// 🔹 Editar imagen y nombre de la categoría
const editarCategoria = async (categoria) => {
  const db = getDatabase();
  setEditCategoria(categoria);

  // Obtener la imagen actual (pero dejar vacío el input)
  const imgRef = ref(db, `nature/Awoo/Img/${categoria}`);
  const snapshotImg = await get(imgRef);
  setEditImg(""); // Se mantiene vacío hasta que el usuario ingrese una nueva imagen

  // Obtener los servicios y buscar en cuál está la categoría
  const serviciosRef = ref(db, "nature/Awoo/Control/Servicios");
  const snapshotServicios = await get(serviciosRef);

  let servicioActual = ""; // Aquí almacenamos el servicio donde se encuentra la categoría
  let serviciosLista = [];

  if (snapshotServicios.exists()) {
    const serviciosData = snapshotServicios.val();
    for (const servicio in serviciosData) {
      if (serviciosData[servicio] && typeof serviciosData[servicio] === "object") {
        if (Object.keys(serviciosData[servicio]).includes(categoria)) {
          servicioActual = servicio; // Guardamos el servicio actual donde está la categoría
        }
      }
      serviciosLista.push(servicio); // Guardamos la lista de servicios
    }
  }

  setSelectedServicio(servicioActual); // Ahora sí selecciona correctamente el servicio actual
  setServicios(serviciosLista);
  setOpenEditDialog(true);
};

// 🔹 Guardar cambios en la categoría
const guardarEdicionCategoria = async () => {
  if (!editCategoria || !selectedServicio) {
    alert("⚠️ Debes seleccionar al menos un servicio.");
    return;
  }

  const db = getDatabase();

  // Si el usuario ingresó una imagen nueva, la guardamos
  if (editImg.trim() !== "") {
    await set(ref(db, `nature/Awoo/Img/${editCategoria}`), editImg);
  }

  // Buscar y eliminar la categoría del servicio anterior si cambió
  const serviciosRef = ref(db, "nature/Awoo/Control/Servicios");
  const snapshotServicios = await get(serviciosRef);

  if (snapshotServicios.exists()) {
    const serviciosData = snapshotServicios.val();
    for (const servicio in serviciosData) {
      if (servicio !== selectedServicio && Object.keys(serviciosData[servicio]).includes(editCategoria)) {
        await remove(ref(db, `nature/Awoo/Control/Servicios/${servicio}/${editCategoria}`));
      }
    }
  }

  // Asignar la categoría al nuevo servicio seleccionado
  await set(ref(db, `nature/Awoo/Control/Servicios/${selectedServicio}/${editCategoria}`), "");

  setOpenEditDialog(false);
  window.location.reload();
};

///////////////////////
const cerrarSesion = () => {
  localStorage.removeItem("adminKey");
  localStorage.removeItem("adminAuthTime");
  window.location.reload();
};
/////////////////

///////////////////////////CODIGO PARA LOGICA DE BOTONES INICIALES 
const handleAdminAccess = () => {
  setDialogOpen(true);
};


const handleGuardar = () => {
  const updates = {
    "nature/Awoo/Control/Seguridad/Pedidos": claves.Pedidos,
    "nature/Awoo/Control/Seguridad/Servicios/Cocina": claves.Cocina,
    "nature/Awoo/Control/Seguridad/Servicios/Bar": claves.Bar,
    "nature/Awoo/Control/Seguridad/Admin": claves.Admin, // nueva
  };

  Object.entries(updates).forEach(([path, value]) => {
    set(ref(db, path), value);
  });

    // Alerta si se modificó la clave de administrador
    if (claves.Admin !== originalClaves.Admin) {
      alert("🔐 Has actualizado la clave del administrador. La sesión actual seguirá activa, pero necesitarás usar la nueva clave para futuros accesos.");
    }

  alert("✅ Claves actualizadas correctamente.");
  setShowDialog(false);
};

const hayCambios =
  claves.Pedidos !== originalClaves.Pedidos ||
  claves.Cocina !== originalClaves.Cocina ||
  claves.Bar !== originalClaves.Bar ||
  claves.Admin !== originalClaves.Admin; // nuevo

///////////////////////////////////

  return (


    <ProteccionAdmin>
<div style={{ display: 'flex', height: '100vh', overflow: 'hidden' ,maxWidth: "100%",  background: 'linear-gradient(135deg, #101010, #101010)', // Fondo degradado blanco a azul
      position: 'relative', // Necesario para posicionar el contenido y la animación de fondo
      }}>
  {/* Contenido deslizable */}
  <div
    style={{
      flex: 1, // Esto asegura que ocupe todo el espacio disponible arriba de la barra
      overflowY: 'auto', // Permite el scroll vertical en el contenido
    }}
  >
    {/* Aquí va todo el contenido deslizable */}
    <div style={{ width:'100%'}}>
     
    <div
    style={{
      background: 'linear-gradient(135deg, #101010, #101010)', // Fondo degradado blanco a azul
      position: 'relative', // Asegura que el contenido esté en una capa superior
      width:'100%'
    }}
  >
 
{/* SALUDO INICIAL A USUARIO */}
<div
      style={{
        backgroundColor: '#000', // Fondo para todo el contenedor
        width: '100%', // Se asegura que ocupe todo el ancho del contenedor padre
      }}
    >
      {/* Tarjeta de usuario */}
      <div
        className="line-layout-container"
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'black',
          padding: '16px',
          borderRadius: '8px',
          minWidth: '350px', // Asegura un tamaño mínimo para cada tarjeta
          marginRight: '16px', // Espaciado entre elementos
          flexShrink: 0, // Evita que los elementos se compriman
        }}
      >
{/* CardView circular con marco azul */}
<div
  className="user-card-outer"
  style={{
    width: '100px', // Tamaño externo del marco
    height: '100px',
    borderRadius: '50%', // Hacerlo circular
    backgroundColor: '#26e9f6', // Color del marco
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '16px', // Espaciado con otros elementos
  }}
>
  {/* Contenedor interno para la imagen */}
  <div
    className="user-card-inner"
    style={{
      width: '95px', // Tamaño interno del contenedor de la imagen
      height: '95px',
      borderRadius: '50%', // Mantener circular
      overflow: 'hidden',
      backgroundColor: '#444',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <img
      src={'images/dragonfondo.png'}
      alt=""
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = 'dragonfondo.png';
      }}
    />
  </div>
</div>


        {/* Texto del usuario */}
        <div className="user-info" style={{ marginRight: '16px' }}>
          <span
            className="user-name"
            style={{
              color: 'white',
              fontWeight: 'bold',
              fontSize: '20px',
              fontFamily: 'Madjoe',
            }}
          >
            {'3DFyrion' || '3DFyrion'}
          </span>
          <br />
          <span
            className="user-email"
            style={{
              color: 'white',
              fontSize: '11px',
              fontFamily: 'Arial, sans-serif',
              opacity: 0.8,
            }}
          >
            {'3DFyrion@gmail.com'}
          </span>
        </div>

        {/* Imagen del tio rico completamente a la derecha */}
        <div
          className="card-play"
          style={{
            backgroundColor: '#101010',
            borderRadius: '50%',
            padding: '4px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '40px',
            height: '40px',
            marginLeft: '30px',
          }}
        >
          <img
            src="images/tio.png"
            alt="Hongo"
            className="image-play"
            style={{ width: '65px', height: '65px' }}
          />
        </div>
      </div>
    </div>


    {/* Animación de fondo */}
    <Lottie
      animationData={animacionSeleccionada} // Importa correctamente la animación JSON
      play
      loop
      style={{
        position: 'absolute', // Fija la animación al fondo de la ventana
        width: '300px',
        height: '300px',
        top: '0',
        left: '0',
        zIndex: 0, // Detrás del contenido
        pointerEvents: 'none', // Para que no interfiera con los clics
      }}
    />


{/* BOTONES INICIALES (Contraseña/Rendimiento/Registro) */}
<div
  style={{
    backgroundColor:'#000',
    display: "flex",
    justifyContent: "flex-end", // Alinea todo a la derecha
    alignItems: "right", // Alineación vertical centrada
    gap: "10px", // Espacio entre los botones
    paddingRight: "25px", // Ajuste para separarlo de la derecha si es necesario
  }}
>

<AdminClaveDialog
  open={dialogOpen}
  onClose={() => setDialogOpen(false)}
  onSuccess={() => setAdminVerificado(true)}
/>


  {/* Contraseña */}
  <div
    onClick={handleAdminAccess}
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px",
      backgroundColor: "#ffffff",
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      width: "25px",
      height: "25px",
      cursor: "pointer",
    }}
  >
    <strong style={{ color: "#000000", fontSize: "16px" }}>🔐</strong>
  </div>

  {/* Rendimiento */}
  <div
    onClick={() => navigate("/awoorendimiento")}
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px",
      backgroundColor: "#ffffff",
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      width: "110px",
      height: "25px",
      cursor: "pointer",
    }}
  >
    <strong style={{ color: "#000000", fontSize: "14px" }}>🌀 Rendimiento</strong>
  </div>

  {/* Registro */}
  <div
  onClick={() => navigate("/awooregistro")}
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px",
      backgroundColor: "#ffffff",
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      width: "110px",
      height: "25px",
      cursor: "pointer",
    }}
  >
    <strong style={{ color: "#000000", fontSize: "14px" }}>🖋️ Registro</strong>
  </div>
</div>




{/* AlertDialog de claves CONTRASEÑA VISTA*/}
{showDialog && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999
        }}>
         <div style={{
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999
}}>
  <div style={{
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "90%",
    maxWidth: "400px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center" // Centra todo el contenido horizontalmente
  }}>
    <h3 style={{ textAlign: "center" }}>🔐 Claves de Seguridad</h3>
    {loading ? <p>Cargando claves...</p> : (
      <>
        <label style={{ marginTop: "10px" }}>📦 Pedidos:</label>
        <input
          value={claves.Pedidos}
          onChange={(e) => setClaves({ ...claves, Pedidos: e.target.value })}
          style={{
            width: "50%",
            padding: "8px",
            marginBottom: "10px",
            textAlign: "center"
          }}
        />

        <label style={{ marginTop: "10px" }}>👨‍🍳 Cocina:</label>
        <input
          value={claves.Cocina}
          onChange={(e) => setClaves({ ...claves, Cocina: e.target.value })}
          style={{
            width: "50%",
            padding: "8px",
            marginBottom: "10px",
            textAlign: "center"
          }}
        />

        <label style={{ marginTop: "10px" }}>🍹 Bar:</label>
        <input
          value={claves.Bar}
          onChange={(e) => setClaves({ ...claves, Bar: e.target.value })}
          style={{
            width: "50%",
            padding: "8px",
            marginBottom: "10px",
            textAlign: "center"
          }}
        />

<label style={{ marginTop: "10px" }}>🔑 Admin:</label>
<input
  value={claves.Admin}
  onChange={(e) => setClaves({ ...claves, Admin: e.target.value })}
  style={{
    width: "50%",
    padding: "8px",
    marginBottom: "10px",
    textAlign: "center"
  }}
/>


        <div style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "15px"
        }}>
          <button
            onClick={() => setShowDialog(false)}
            style={{
              backgroundColor: "#aaa",
              padding: "8px 15px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer"
            }}
          >
            Cancelar
          </button>

          {hayCambios && (
            <button
              onClick={handleGuardar}
              style={{
                backgroundColor: "#4CAF50",
                color: "#fff",
                padding: "8px 15px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer"
              }}
            >
              Guardar
            </button>
          )}
        </div>
      </>
    )}
  </div>
</div>

        </div>
        )}



  {/* ESTILO CUADRO NEGRO */}
  <div
      className="container"
      style={{
        backgroundColor:'#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '10px',
         width:'100%'
      }}
    >

    </div>
      {/* ESTILO CUADRO AZUL */}
  <div
      className="container"
      style={{
        backgroundColor:'#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '5px',
      }}
    >

    </div>




  {/* CODIGO ONLINE ESTADO CONTRASEÑA CORRECTA Y BTN SALIDA */}
  <div style={{ position: "relative" }}>
        <div style={{
          position: "fixed", top: 20, right: 20, background: "#111",
          padding: "10px 15px", borderRadius: "8px", display: "flex",
          alignItems: "center", gap: "10px", boxShadow: "0 0 10px #000",
          zIndex: 999
        }}>
          <span style={{ color: "#4CAF50", fontWeight: "bold", fontSize: "14px" }}>🟢 Online</span>
          <button
            onClick={() => setMostrarConfirmacion(true)}
            style={{
              background: "#e53935", color: "#fff", fontWeight: "bold",
              border: "none", borderRadius: "5px", padding: "5px 10px",
              cursor: "pointer", display: "flex", alignItems: "center", gap: "5px"
            }}
          >
            🚪 Salir
          </button>
        </div>
      </div>

      {/* MODAL DE CONFIRMACIÓN */}
      {mostrarConfirmacion && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.6)", display: "flex",
          justifyContent: "center", alignItems: "center", zIndex: 1000
        }}>
          <div style={{
            background: "#1e1e1e", padding: "25px", borderRadius: "12px",
            boxShadow: "0 0 15px rgba(0,0,0,0.7)", maxWidth: "90%",
            textAlign: "center", color: "#fff"
          }}>
            <h3 style={{ marginBottom: "15px" }}>¿Estás seguro de cerrar sesión?</h3>
            <p style={{ fontSize: "14px", marginBottom: "25px" }}>
              Esto eliminará la contraseña actual del navegador y deberás ingresarla nuevamente.
            </p>
            <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
              <button
                onClick={() => setMostrarConfirmacion(false)}
                style={{
                  background: "#666", border: "none", borderRadius: "5px",
                  padding: "8px 16px", color: "#fff", cursor: "pointer"
                }}
              >
                Cancelar
              </button>
              <button
                onClick={cerrarSesion}
                style={{
                  background: "#e53935", border: "none", borderRadius: "5px",
                  padding: "8px 16px", color: "#fff", fontWeight: "bold",
                  cursor: "pointer"
                }}
              >
                Confirmar salida
              </button>
            </div>
          </div>
        </div>
        )}



{/* Sección de PEDIDOS (APROBADOS/CANCELAR) */}
{/* -- Titulo PEDIDOS */}
<div
  style={{
    display: "flex",
    alignItems: "center", // Alinea elementos verticalmente
    gap: "10px", // Espacio entre elementos
    marginTop: "-40px",
    textAlign: "left",
    marginLeft: "25px",
    color: "white",
  }}
>
<div
            style={{
              display: "flex",
              marginTop: "45px",
              flexDirection: "row", // Disposición horizontal
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              marginLeft: "1px",
              borderRadius: "10px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              width: "120px", // Aumenta el ancho mínimo para dar espacio
              cursor: "pointer",
            }}
          >
            <strong style={{ color: "#FFF", fontSize: "14px" }}>{"⭐ Pedidos 🔥 "}</strong>
           
          </div>

</div>

  {/* -- CARDVIEWS lista de ORDENES */}

  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflowX: "auto",
      whiteSpace: "nowrap",
      padding: "5px 0",
    }}
  >
    <div
      style={{
        marginBottom: "20px",
        textAlign: "left",
        width: "80%",
        backgroundColor: "#000",
        borderRadius: "15px",
        padding: "15px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
        maxWidth: "100%",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          overflowX: "auto",
          whiteSpace: "nowrap",
          width: "100%",
          paddingBottom: "10px",
          height: "270px",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            minWidth: "max-content",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          {/* --- Tarjeta Ordenes --- */}
          <Box>
            {pedidos.map((pedido) => (
              <Card
                key={pedido.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 2,
                  p: 2,
                  cursor: "pointer",
                  position: "relative",
                  border: "3px solid #2BF9FF",
                  borderRadius: 2,
                }}
                onClick={() => {
                  setPedidoSeleccionado(pedido);
                  setPedidoEditable({ ...pedido }); // inicializa editable con la orden
                  setOpen(true);
                }}
              >
                {/* Botón de cierre (X) */}
                <Card
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    backgroundColor: "red",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    fontSize: 14,
                    fontWeight: "bold",
                    position: "absolute",
                    top: 1,
                    left: 1,
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    eliminarPedido(pedido.id);
                  }}
                >
                  X
                </Card>

                {/* Indicador (mesa o categoria) */}
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "2px solid gray",
                    mr: 2,
                  }}
                >
                  <Typography variant="h7" fontWeight="bold">
                    {pedido.mesa || "🔥"}
                  </Typography>
                </Box>

                {/* Información */}
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h7" fontWeight="bold">
                    {pedido.producto || pedido.titular || pedido.nombre || "Orden"}
                  </Typography>
                  <Typography variant="subtitle2" color="green">
                    💰 Total: $
                    {(
                      pedido.precioTotal ??
                      pedido.totalPedido ??
                      0
                    ).toLocaleString
                      ? (pedido.precioTotal ?? pedido.totalPedido ?? 0).toLocaleString(
                          "es-CO"
                        )
                      : (pedido.precioTotal ?? pedido.totalPedido ?? 0)}
                  </Typography>
                  <Typography variant="caption" color="gray">
                    Estado: {"Pendiente"}
                  </Typography>
                </Box>

                {/* Botón CONFIRMAR */}
                <Card
                  sx={{
                    backgroundColor: "#2BF9FF",
                    color: "black",
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "13px",
                    marginLeft: "15px",
                    width: "90px",
                    textAlign: "center",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    confirmarPedido(pedido);
                  }}
                >
                  CONFIRMAR
                </Card>
              </Card>
            ))}

           {/* MODAL DE RESUMEN / EDITAR ORDEN */}
            <Modal
              isOpen={open}
              onRequestClose={() => setOpen(false)}
              style={{
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                },
                content: {
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "transparent",
                  border: "none",
                },
              }}
            >
              <Box
                id="factura"
                sx={{
                  width: 320,
                  maxHeight: "60vh",
                  overflowY: "auto",
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  p: 3,
                  borderRadius: "10px",
                  border: "1px solid #ccc",
                }}
              >
                {pedidoSeleccionado && (
                  <>
                    <Box textAlign="center" mb={2}>
                      <Typography variant="h4" fontWeight="bold">
                        {datosEmpresa?.Empresa || "Empresa"}
                      </Typography>
                      <Typography variant="body2" color="gray">
                        {datosEmpresa?.Descripción || "Descripción"}
                      </Typography>
                      <Typography variant="body2" color="gray">
                        {datosEmpresa?.Dirección || "Dirección no disponible"}
                      </Typography>
                      <Typography variant="body2" color="gray">
                        {datosEmpresa?.Celular || "Teléfono no disponible"}
                      </Typography>
                     </Box>

                    <Divider sx={{ my: 1 }} />

                    <Box textAlign="center" mb={2}>
                      <Typography variant="h8" fontWeight="bold">
                        Factura Venta
                      </Typography>
                      <Typography variant="body2" color="gray">
                        {numeroFactura.toString().padStart(5, "0")}
                      </Typography>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    <Box textAlign="center" mb={2}>
                      <Typography variant="h8" fontWeight="bold">
                        Fecha:
                      </Typography>
                      <Typography variant="body2" color="gray">
                        {pedidoSeleccionado.fecha || ""}
                      </Typography>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                

                    {/* Cliente / titular */}
                    <Typography variant="body1" fontWeight="bold">
                      Cliente: {pedidoSeleccionado.titular || pedidoSeleccionado.producto || pedidoSeleccionado.nombre || "—"}
                    </Typography>

                    
                    {/* Cliente / titular */}
                    <Typography variant="body1" fontWeight="bold">
                      Email: {pedidoSeleccionado.email ||  "—"}
                    </Typography>

                    <Divider sx={{ my: 1 }} />

                    {/* Si la orden trae 'productos' (array) renderizamos la UI antigua,
                        si no, renderizamos los campos individuales de la orden */}
                    {Array.isArray(pedidoEditable?.productos) &&
                    pedidoEditable.productos.length > 0 ? (
                      pedidoEditable.productos.map((producto, index) => (
                        <Box
                          key={index}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          my={1}
                        >
                          <Typography sx={{ width: "45%", fontSize: "13px" }}>{producto.titulo || producto.nombre + " - " + producto.varianteNombre + " - " + " $" + producto.preciound }</Typography>


                          <TextField
                            type="number"
                            value={producto.cantidad}
                            onChange={(e) => {
                              const nuevosProductos = [...pedidoEditable.productos];
                              const nuevaCantidad = parseInt(e.target.value) || 0;
                              nuevosProductos[index].cantidad = nuevaCantidad;

                              const nuevoTotal = nuevosProductos.reduce((acc, prod) => {
                                const cantidad = prod.cantidad || 0;
                                const precio = prod.precioUnitario || prod.preciound || 0;
                                return acc + cantidad * precio;
                              }, 0);

                              setPedidoEditable({
                                ...pedidoEditable,
                                productos: nuevosProductos,
                                totalPedido: nuevoTotal,
                              });
                            }}
                            inputProps={{ min: 1 }}
                            sx={{ width: "60px", mr: 1,
                              opacity: 0,
                              padding: 0,
                              minWidth: 0,
                              width: "0px",
                              height: "0px", }}
                            size="small"
                          />


<Box
  sx={{
    width: "30px",
    mr: 1,
    padding: "6px 8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "15px",
    textAlign: "center",
    backgroundColor: "#f5f5f5",
  }}
>
  {producto.cantidad}
</Box>





                          <Button
                            variant="outlined"
                            color="error"
                            onClick={() => {
                              const nuevosProductos = pedidoEditable.productos.filter(
                                (_, i) => i !== index
                              );

                              const nuevoTotal = nuevosProductos.reduce((acc, prod) => {
                                const cantidad = prod.cantidad || 0;
                                const precio = prod.precioUnitario || prod.preciound || 0;
                                return acc + cantidad * precio;
                              }, 0);

                              setPedidoEditable({
                                ...pedidoEditable,
                                productos: nuevosProductos,
                                totalPedido: nuevoTotal,
                              });
                            }}
                            sx={{
                              opacity: 0,
                              padding: 0,
                              minWidth: 0,
                              width: "0px",
                              height: "0px",
                            }}
                          >
                            ❌
                          </Button>

                        </Box>
                      ))
                    ) : (
                      // Orden simple (campos individuales)
                      <>
                        <TextField
                          label="Categoría"
                          value={pedidoEditable.categoria || ""}
                          onChange={(e) =>
                            setPedidoEditable({ ...pedidoEditable, categoria: e.target.value })
                          }
                          fullWidth
                          size="small"
                          sx={{ mb: 1 }}
                        />
                        <TextField
                          label="Producto"
                          value={pedidoEditable.producto || ""}
                          onChange={(e) =>
                            setPedidoEditable({ ...pedidoEditable, producto: e.target.value })
                          }
                          fullWidth
                          size="small"
                          sx={{ mb: 1 }}
                        />
                        <TextField
                          label="Descripción"
                          value={pedidoEditable.descripcion || ""}
                          onChange={(e) =>
                            setPedidoEditable({ ...pedidoEditable, descripcion: e.target.value })
                          }
                          fullWidth
                          size="small"
                          sx={{ mb: 1 }}
                        />
                        <TextField
                          label="Cantidad"
                          type="number"
                          value={pedidoEditable.cantidad || 0}
                          onChange={(e) =>
                            setPedidoEditable({
                              ...pedidoEditable,
                              cantidad: parseFloat(e.target.value) || 0,
                            })
                          }
                          fullWidth
                          size="small"
                          sx={{ mb: 1 }}
                        />
                        <TextField
                          label="Precio UND"
                          type="number"
                          value={pedidoEditable.precioUnd || 0}
                          onChange={(e) =>
                            setPedidoEditable({
                              ...pedidoEditable,
                              precioUnd: parseFloat(e.target.value) || 0,
                            })
                          }
                          fullWidth
                          size="small"
                          sx={{ mb: 1 }}
                        />
                        <TextField
                          label="Costo UND"
                          type="number"
                          value={pedidoEditable.costoUnd || 0}
                          onChange={(e) =>
                            setPedidoEditable({
                              ...pedidoEditable,
                              costoUnd: parseFloat(e.target.value) || 0,
                            })
                          }
                          fullWidth
                          size="small"
                          sx={{ mb: 1 }}
                        />
                        <TextField
                          label="Estado"
                          value={pedidoEditable.estado || ""}
                          onChange={(e) =>
                            setPedidoEditable({ ...pedidoEditable, estado: e.target.value })
                          }
                          fullWidth
                          size="small"
                          sx={{ mb: 1 }}
                        />
                      </>
                    )}

                    <Divider sx={{ my: 1 }} />

                    {/* Mostrar total recalculado si existe */}
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      textAlign="right"
                      color="black"
                    >
                      {/* Calcula total tomando preferiblemente totalPedido o precioTotal */}
                      Total: $
                      {(
                        pedidoEditable?.precioTotal ??
                        pedidoEditable?.totalPedido ??
                        (pedidoEditable?.precioUnd && pedidoEditable?.cantidad
                          ? pedidoEditable.precioUnd * pedidoEditable.cantidad
                          : 0)
                      ).toLocaleString
                        ? (
                            pedidoEditable?.precioTotal ??
                            pedidoEditable?.totalPedido ??
                            (pedidoEditable?.precioUnd && pedidoEditable?.cantidad
                              ? pedidoEditable.precioUnd * pedidoEditable.cantidad
                              : 0)
                          ).toLocaleString("es-CO")
                        : (
                            pedidoEditable?.precioTotal ??
                            pedidoEditable?.totalPedido ??
                            (pedidoEditable?.precioUnd && pedidoEditable?.cantidad
                              ? pedidoEditable.precioUnd * pedidoEditable.cantidad
                              : 0)
                          )}
                    </Typography>

                    <Divider sx={{ my: 1 }} />

                    <Box textAlign="center" mb={2}>
                      <Typography variant="body2" color="gray">
                        FACTURACIÓN ELECTRÓNICA SEGUN RESOLUCIÓN DIAN No.18763003159636...
                      </Typography>
                    </Box>
                  </>
                )}
              </Box>

              <Box id="botonesFactura" sx={{ mt: 2 }}>
                {/* Descargar factura */}
                {JSON.stringify(pedidoEditable) === JSON.stringify(pedidoSeleccionado) && (
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    sx={{ mb: 2, borderRadius: "10px" }}
                    onClick={descargarFactura}
                  >
                    Descargar Factura
                  </Button>
                )}

                {/* Guardar cambios (si hubo ediciones) */}
                {pedidoEditable &&
                  JSON.stringify(pedidoEditable) !== JSON.stringify(pedidoSeleccionado) && (
                    <Button
                      variant="contained"
                      color="success"
                      fullWidth
                      sx={{ mb: 2, borderRadius: "10px" }}
                      onClick={async () => {
                        const db = getDatabase(app);
                        const pedidoRef = ref(db, `nature/Awoo/Ordenes/${pedidoEditable.id}`);

                        // Recalcular precioTotal si no existe
                        let precioTotalNuevo =
                          pedidoEditable.precioTotal ?? pedidoEditable.totalPedido ?? 0;

                        if (!pedidoEditable.precioTotal && pedidoEditable.precioUnd && pedidoEditable.cantidad) {
                          precioTotalNuevo = pedidoEditable.precioUnd * pedidoEditable.cantidad;
                        }

                        const cambios = {
                          ...pedidoEditable,
                          precioTotal: precioTotalNuevo,
                        };

                        try {
                          // No uses set(...) para no sobreescribir accidentalmente otras ramas
                          await update(pedidoRef, cambios);
                          setOpen(false);
                          console.log("Orden actualizada");
                        } catch (error) {
                          console.error("Error actualizando orden:", error);
                        }
                      }}
                    >
                      Guardar Cambios
                    </Button>
                  )}

                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ borderRadius: "10px" }}
                  onClick={() => setOpen(false)}
                >
                  Cerrar
                </Button>
              </Box>
            </Modal>
          </Box>
        </div>
      </div>
    </div>
  </div>
);





{/* --  BOTONES PERSONAL Y LINK  */}
<div style={{ display: "flex", justifyContent: "center", gap: "10px", margin: "20px 0" , marginTop:"-15px"}}>
<PersonalDialog />
 

  {/* Links */}
  <div
    onClick={obtenerLinks}
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px",
      backgroundColor: "#32f0e1",
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      width: "110px",
      height: "25px",
      cursor: "pointer",
    }}
  >
    <strong style={{ color: "#111", fontSize: "14px" }}>📌 Links</strong>
  </div>

    {/* Clientes */}
    <div
    onClick={irclientesrecurrentes}
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px",
      backgroundColor: "#fba939",
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      width: "110px",
      height: "25px",
      cursor: "pointer",
    }}
  >
    <strong style={{ color: "#fff", fontSize: "14px" }}>😃 Premiar</strong>
  </div>

  <Button
        variant="contained"
        color="primary"
        startIcon={<ReceiptIcon />}
        onClick={handleOpen}
        sx={{ borderRadius: "12px", px: 3 }}
      >
        Generar Orden
      </Button>

      <Dialog open={openOrden} onClose={handleCloseOrden} fullWidth maxWidth="sm">
        <DialogTitle>🧾 Generar Orden</DialogTitle>
        <DialogContent sx={{ mt: 1 }}>
          {/* Categoría */}
          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel>Categoría</InputLabel>
            <Select
              value={categoriaOrden}
              label="Categoría"
              onChange={(e) => {
                setCategoriaOrden(e.target.value);
                setProductoOrden("");
                setMostrarProductosOrden(false);
              }}
            >
              {categoriasOrden.map((cat, idx) => (
                <MenuItem key={idx} value={cat}>
                  {cat}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Producto */}
          <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
            <TextField
              fullWidth
              label="Producto"
              variant="outlined"
              value={productoOrden}
              onChange={(e) => setProductoOrden(e.target.value)}
            />
            <IconButton onClick={cargarProductosOrden} sx={{ ml: 1 }}>
              🍱
            </IconButton>
          </Box>

          {/* Lista de productos */}
          {mostrarProductosOrden && productosOrden.length > 0 && (
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel>Selecciona Producto</InputLabel>
              <Select
                value={productoOrden}
                label="Selecciona Producto"
                onChange={(e) => setProductoOrden(e.target.value)}
              >
                {productosOrden.map((prod, idx) => (
                  <MenuItem key={idx} value={prod}>
                    {prod}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {/* Descripción */}
          <TextField
            fullWidth
            label="Descripción (opcional)"
            multiline
            rows={2}
            variant="outlined"
            value={descripcionOrden}
            onChange={(e) => setDescripcionOrden(e.target.value)}
            sx={{ mt: 2 }}
          />

          {/* Precio, Cantidad, Costo */}
          <TextField
            fullWidth
            label="Precio UND"
            type="number"
            variant="outlined"
            value={precioUndOrden}
            onChange={(e) => setPrecioUndOrden(e.target.value)}
            sx={{ mt: 2 }}
          />

          <TextField
            fullWidth
            label="Cantidad"
            type="number"
            variant="outlined"
            value={cantidadOrden}
            onChange={(e) => setCantidadOrden(e.target.value)}
            sx={{ mt: 2 }}
          />

          <TextField
            fullWidth
            label="Costo UND"
            type="number"
            variant="outlined"
            value={costoUndOrden}
            onChange={(e) => setCostoUndOrden(e.target.value)}
            sx={{ mt: 2 }}
          />

          {/* Resumen Totales */}
          <Box sx={{ mt: 3, p: 2, background: "#f7f7f7", borderRadius: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              🔹 Resumen de Totales
            </Typography>
            <Typography variant="body1">
              Precio Total: <strong>${precioTotalOrden || "0.00"}</strong>
            </Typography>
            <Typography variant="body1">
              Costo Total: <strong>${costoTotalOrden || "0.00"}</strong>
            </Typography>
            <Typography variant="body1" sx={{ color: "green" }}>
              Ganancia Total: <strong>${gananciaTotalOrden || "0.00"}</strong>
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseOrden} color="error">
            Cancelar
          </Button>
          <Button onClick={handleGuardarOrden} color="success" variant="contained">
            Guardar Orden
          </Button>
        </DialogActions>
      </Dialog>

</div>

   {/* Modal de Links */}
   {mostrarLinks && (
  <div style={{
    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
    backgroundColor: "rgba(0,0,0,0.8)", display: "flex",
    justifyContent: "center", alignItems: "center", zIndex: 9999,
    padding: "10px",
  }}>
    <div style={{
      background: "#fff", padding: "20px", borderRadius: "10px",
      width: "100%", maxWidth: "400px", maxHeight: "80vh",
      overflowY: "auto", boxShadow: "0 0 20px #000", position: "relative"
    }}>
      <h2 style={{ textAlign: "center", marginBottom: "20px", fontSize: "18px" }}>🔗 Lista de Links</h2>

      {Object.entries(links).map(([nombre, link]) => (
        <div key={nombre} style={{
          display: "flex", flexDirection: "row", alignItems: "center",
          justifyContent: "space-between", marginBottom: "15px",
          backgroundColor: "#f3f3f3", padding: "10px", borderRadius: "8px",
          flexWrap: "wrap"
        }}>
          <div style={{
            flex: "1 1 auto", minWidth: "40%",
            wordBreak: "break-word", color: "#333"
          }}>
            <strong style={{ fontSize: "15px" }}>{nombre}</strong><br />
            <span style={{ fontSize: "13px", color: "#555", width:"100px" }}>{link}</span>
          </div>

          <button
            onClick={() => copiarAlPortapapeles(link)}
            style={{
              backgroundColor: "#4CAF50", color: "#fff",
              border: "none", padding: "8px 12px", borderRadius: "5px",
              cursor: "pointer", fontSize: "14px", marginLeft: "10px", marginTop: "10px"
            }}
          >
            📋 Copiar
          </button>
        </div>
      ))}

      {/* Botón cerrar */}
      <button
        onClick={() => setMostrarLinks(false)}
        style={{
          position: "absolute", top: "10px", right: "10px",
          backgroundColor: "transparent", border: "none",
          fontSize: "20px", cursor: "pointer", color: "#333"
        }}
      >
        ✖
      </button>
    </div>
  </div>
)}








{/* --  VISITAS PARA PREMIO  */}
{/* -- Titulo visitas */}
{/* -- Título con campo de edición horizontal */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "15px", // Espacio entre el texto y el input
    marginLeft: "25px",
    marginTop: "40px",
  }}
>
  {/* Título */}
  <div
    style={{
      padding: "10px",
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      cursor: "default",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      fontWeight: "bold",
      fontSize: "14px",
    }}
  >
    🧐 Visitas para Premio: 🎉
  </div>

  {/* Campo de texto editable */}
  <TextField
    label=""
    type="number"
    variant="outlined"
    value={limiteVisitas}
    onChange={(e) => {
      const nuevoValor = Number(e.target.value);
      setLimiteVisitas(nuevoValor);
      const db = getDatabase(app);
      set(ref(db, "nature/Awoo/Control/PremiarVisitas"), nuevoValor);
    }}
    sx={{
      background: "#fff",
      borderRadius: 2,
      width: 80,
      input: {
        color: "#000",
        fontWeight: "bold",
        textAlign: "center",
        fontSize: "18px",
      },
    }}
    inputProps={{ min: 1 }}
  />
</div>

{/* -- Info Control visitas */}
<div style={{ padding: 20 , marginLeft:"20px"}}>
      <div style={{ display: "flex", alignItems: "center", gap: 20 }}>

        {clientesFiltrados.length > 0 && (
          <div
            style={{
              display: "flex",
              overflowX: "auto",
              gap: 10,
              paddingBottom: 10,
              flexGrow: 1,
            }}
          >
            {clientesFiltrados.map((cliente, index) => {
              const mesaActual = cliente.pedidos[cliente.pedidos.length - 1]?.mesa || "No registrada";

              return (
                <div
                  key={index}
                  style={{
                    minWidth: 220,
                    backgroundColor: "#f5f5f5",
                    borderRadius: 10,
                    padding: 10,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setClienteSeleccionado(cliente);
                    setOpenDialog(true);
                  }}
                >
                  <Typography variant="subtitle2">📧 {cliente.correo}</Typography>
                  <Typography variant="body2">🧾 Visitas: {cliente.visitas}</Typography>
                  <Typography variant="body2">💰 ${cliente.totalGastado.toLocaleString()}</Typography>
                  <Typography variant="body2">📍 Mesa: {mesaActual}</Typography>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>
          🧾 Pedidos de {clienteSeleccionado?.correo}
        </DialogTitle>
        <DialogContent dividers style={{ maxHeight: 400 }}>
          {clienteSeleccionado?.pedidos.map((pedido, idx) => (
            <div
              key={idx}
              style={{
                marginBottom: 15,
                borderBottom: "1px solid #ccc",
                paddingBottom: 10,
              }}
            >
              <Typography variant="subtitle2">
                📅 {pedido.fecha} 🕐 {pedido.hora} | 📍 Mesa: {pedido.mesa || "No registrada"}<br />
                💰 ${pedido.totalPedido.toLocaleString()}
              </Typography>
              <ul style={{ paddingLeft: 20 }}>
                {pedido.productos &&
                  Object.values(pedido.productos).map((p, i) => (
                    <li key={i}>
                      {p.cantidad}x {p.titulo} (${p.precioUnitario})
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </DialogContent>
        <div style={{ padding: 20, display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              if (window.confirm("¿Está seguro que se premió al cliente?")) {
                premiarCliente(clienteSeleccionado);
              }
            }}
          >
            🎁 PREMIADO
          </Button>
          <Button onClick={() => setOpenDialog(false)}>Cerrar</Button>
        </div>
      </Dialog>
    </div>







{/* Sección de Mesas (Agregar/Eliminar) */}
{/* -- Titulo Mesas */}
<div
  style={{
    display: "flex",
    alignItems: "center", // Alinea elementos verticalmente
    gap: "10px", // Espacio entre elementos
    marginBottom: "20px",
    textAlign: "left",
    marginLeft: "25px",
    color: "white",
  }}
>
<div
            style={{
              display: "flex",
              marginTop: "45px",
              flexDirection: "row", // Disposición horizontal
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              borderRadius: "10px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              width: "100px", // Aumenta el ancho mínimo para dar espacio
              cursor: "pointer",
            }}
          >
            <strong style={{ color: "#FFF", fontSize: "16px" }}>{"💥 Mesas: "}</strong>
          
          </div>


{/* Imagen 1 */}
<div
    style={{
      marginLeft:"-25px",
      backgroundColor: "#2ae5e2",
      borderRadius: "50%",
      padding: "2px", // Espacio para que se vea el borde
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "40px",
    }}

    onClick={() => {
      if (window.confirm("¿Estás seguro de crear una nueva mesa?")) {
        agregarMesa();
      }
    }}
  >
    <img
      src={"images/ad.jpg"}
      alt="Agregar Mesa"
      style={{
        width: "35px",
        height: "35px",
        borderRadius: "50%",
      }}
    />
  </div>

  {/* Imagen 2 */}
  <div
    style={{
      backgroundColor: "#2ae5e2",
      borderRadius: "50%",
      padding: "2px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "40px",
    }}
    onClick={() => {
      if (window.confirm("¿Estás seguro de eliminar la última mesa?")) {
        eliminarMesa();
      }
    }}
  >
    <img
      src={"images/bor.jpg"}
      alt="Eliminar Mesa"
      style={{
        width: "35px",
        height: "35px",
        borderRadius: "50%",
      }}
    />
  </div>
</div>
{/* -- CARDVIEWS Circulares Mesas -- */}
<div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflowX: "auto",
        whiteSpace: "nowrap",
        padding: "5px 0",
      }}
    >
      <div
        style={{
          marginBottom: "20px",
          textAlign: "left",
          width: "80%",
          backgroundColor: "#000",
          borderRadius: "15px",
          padding: "15px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
          maxWidth: "100%",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            overflowX: "auto",
            whiteSpace: "nowrap",
            width: "100%",
            paddingBottom: "10px",
            height: "150px",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "nowrap",
              minWidth: "max-content",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            {mesas.map((mesa) => (
              <div
                key={mesa.numero}
                style={{
                  marginLeft: "15px",
                  position: "relative",
                  width: "100px",
                  flexShrink: 0,
                  cursor: "pointer", // Hace clickeables las mesas
                }}
                onClick={() => openModal(mesa)} // Evento de clic para abrir el QR
              >
                <div
                  style={{
                    position: "relative",
                    borderRadius: "15px",
                    overflow: "visible",
                  }}
                >
                  {/* Círculo blanco con número de mesa */}
                  <div
                    style={{
                      width: "100%",
                      height: "100px",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      border: "5px solid #2ae5e2",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "36px",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {mesa.numero}
                    </span>
                  </div>

                  {/* Etiqueta inferior */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: "-20px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: "80%",
                      backgroundColor: "#3cca07",
                      color: "white",
                      padding: "8px",
                      borderRadius: "10px",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {`Mesa ${mesa.numero}`}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* MODAL PARA EL QR */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        style={{
          content: {
            width: "300px",
            height: "400px",
            margin: "auto",
            borderRadius: "15px",
            textAlign: "center",
            backgroundColor: "#fff",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
          },
        }}
      >
        <h2 style={{ color: "#333", fontSize: "18px" }}>Mesa {selectedMesa}</h2>

        {/* Contenedor del QR con referencia */}
<div ref={qrRef}>
  <QRCodeCanvas value={selectedURL} size={200} />
</div>

        {/* Link visible */}
        <p
          style={{
            wordBreak: "break-word",
            fontSize: "14px",
            marginTop: "10px",
          }}
        >
          <a href={selectedURL} target="_blank" rel="noopener noreferrer">
            {selectedURL}
          </a>
        </p>
        <button
  onClick={descargarQR}
  style={{
    marginTop: "10px",
    padding: "8px 12px",
    backgroundColor: "#28a745",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    marginRight: "10px",
  }}
>
  📥 Descargar QR
</button>

        {/* Botón para cerrar */}
        <button
          onClick={() => setModalIsOpen(false)}
          style={{
            marginTop: "10px",
            padding: "8px 12px",
            backgroundColor: "#d9534f",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          Cerrar
        </button>
      </Modal>
    </div>





{/* Sección de Categorias */}
{/* -- Titulo Categorias */}
<div
  style={{
    display: "flex",
    alignItems: "center", // Alinea elementos verticalmente
    gap: "10px", // Espacio entre elementos
    marginBottom: "20px",
    marginTop: "-45px",
    textAlign: "left",
    marginLeft: "25px",
    color: "white",
  }}
>
<div
            style={{
              display: "flex",
              marginTop: "45px",
              flexDirection: "row", // Disposición horizontal
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              borderRadius: "10px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              width: "120px", // Aumenta el ancho mínimo para dar espacio
              cursor: "pointer",
            }}
          >
            <strong style={{ color: "#fff", fontSize: "16px" }}>{"🚀 Categorias:"}</strong>
           
          </div>


{/* Imagen 1 */}
<div
    style={{
      marginLeft:"-15px",
      backgroundColor: "#2ae5e2",
      borderRadius: "50%",
      padding: "2px", // Espacio para que se vea el borde
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "40px",
    }}
  >
    <img
      src={"images/ad.jpg"}
      alt="Agregar"
      onClick={() => setOpenAddDialog(true)}
      style={{
        width: "35px",
        height: "35px",
        borderRadius: "50%",
      }}
    />
  </div>

  {/* Imagen 2 */}
  <div
    style={{
      backgroundColor: "#2ae5e2",
      borderRadius: "50%",
      padding: "2px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "40px",
    }}
  >
    <img
      src={"images/bor.jpg"}
      alt="Borrar"
      onClick={() => setOpenDeleteDialog(true)}
      style={{
        width: "35px",
        height: "35px",
        borderRadius: "50%",
      }}
    />
  </div>

{/* Dialogo para Agregar Categoría */}
<Dialog open={openAddDialog} onClose={() => setOpenAddDialog(false)}>
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h3>Agregar Categoría</h3>
        <input
          type="text"
          placeholder="Nombre de la categoría"
          value={categoria}
          onChange={(e) => setCategoria(e.target.value)}
          style={{ display: "block", margin: "10px auto", padding: "5px" }}
        />
        <input
          type="text"
          placeholder="URL de la imagen"
          value={linkImg}
          onChange={(e) => setLinkImg(e.target.value)}
          style={{ display: "block", margin: "10px auto", padding: "5px" }}
        />
<div>
  <h4>Selecciona un Servicio:</h4>
  {Array.isArray(servicios) && servicios.length > 0 ? (
    servicios.map((servicio) => (
      <div key={servicio} style={{ marginBottom: "5px" }}>
        <input
          type="radio"
          name="servicio"
          value={servicio}
          checked={selectedServicio === servicio}
          onChange={(e) => setSelectedServicio(e.target.value)}
        />
        {servicio}
      </div>
    ))
  ) : (
    <p>No hay servicios disponibles</p>
  )}
</div>

        <button onClick={handleAddCategoria}>Guardar</button>
      </div>
    </Dialog>
      
      {/* Dialogo para Eliminar Categoría */}
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <div style={{ padding: "20px", textAlign: "center" }}>
          <h3>Eliminar Categoría</h3>
          {categorias.map((cat) => (
  <div
    key={cat.nombre} // Usa el nombre como clave (siempre único)
    onClick={() => setSelectedCategoria(cat.nombre)} // Guarda solo el nombre
    style={{
      padding: "10px",
      margin: "5px",
      cursor: "pointer",
      backgroundColor: selectedCategoria === cat.nombre ? "#ff6961" : "#f0f0f0",
    }}
  >
    {cat.nombre} {/* Asegúrate de mostrar solo el nombre */}
  </div>
))}

          <button onClick={handleDeleteCategoria}>Eliminar</button>
        </div>
      </Dialog>


</div>



{/* -- CARDVIEWS Categorias */}
<div 
    style={{
      display: "flex",
      justifyContent: "center", // Centra horizontalmente
      alignItems: "center", // Centra verticalmente
      overflowX: "auto",
      whiteSpace: "nowrap",
      padding: "5px 0", // Espaciado interno
    }}
  >

<div 
  style={{ 
    marginBottom: "20px", 
    textAlign: "left", 
    width: "80%",
    backgroundColor: "#000", // Fondo negro
    borderRadius: "15px", // Esquinas redondeadas
    padding: "15px", // Espaciado interno
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)", // Sombra opcional
    maxWidth: "100%", // Evita que se desborde
    overflow: "hidden", // Previene desbordamientos innecesarios
  }}
>
  {/* Contenedor con scroll horizontal */}
  <div 
    style={{
      overflowX: "auto", // Activa scroll horizontal
      whiteSpace: "nowrap", // Evita que los elementos salten de línea
      width: "100%", // Se ajusta al contenedor padre
      paddingBottom: "10px", // Espacio extra para scrollbar
      height:"270px",
      justifyContent: "center", // Centra si hay pocas tarjetas
    }}
  >
    
    {/* Contenedor de tarjetas */}
    <div 
      style={{ 
        display: "flex",
        flexWrap: "nowrap", // Evita que los elementos se ajusten en varias líneas
        minWidth: "max-content", // Permite que el contenido crezca sin apretarse
        gap: "10px", // Espacio entre tarjetas
        justifyContent: "center", // CENTRA LAS TARJETAS cuando hay pocas
      }}
    >



{categorias.map((categoria, index) => (

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", overflowX: "auto", whiteSpace: "nowrap", width: "100%", padding: "10px 0", cursor: "pointer" }}>
           {/* --- Tarjeta 1 Comidas Rápidas --- */}
<div
  style={{
    marginLeft: "15px",
    position: "relative",
    width: "160px",
    flexShrink: 0, // Evita que las tarjetas se reduzcan
  }}
>
<div 
       style={{
        display: "flex",
    justifyContent: "center", // Centra horizontalmente
    alignItems: "center", // Centra verticalmente si tiene altura definida
    overflowX: "auto",
    whiteSpace: "nowrap",
    width: "100%", // Asegura que ocupe todo el ancho
    padding: "10px 0", // Opcional: agrega espacio vertica
      }}>
        
        <div
            style={{
              position: "relative",
              width: "150px",
              display: "inline-block",
              marginRight: "10px",
              marginTop: "10px",
            }}
            //onClick={() => navigate("/vistacontenedor", { state: { ...event } })}
            //onClick={() => handleClick(event)}

          >
            <div
              style={{
                position: "relative",
                borderRadius: "15px",
                overflow: "visible",
              }}
            >
              <img
              
                onClick={() => handleCategoriaClick(categoria.nombre)} // Agregamos onClick
                src={categoria.img}
                alt={`Evento`}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "10%",
                }}
                
              />

               <img
                src={`images/${categoria.visible}`}
                alt="Visibilidad"
                onClick={() => toggleVisibility(categoria.nombre)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                }}
              />

                <img
                src={"images/config.png"}
                alt="Configurar"
                onClick={() => editarCategoria(categoria.nombre)}
                style={{
                  position: "absolute",
                  top: "70px",
                  right: "10px",
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                }}
              />
              
            
              <div
                style={{
                  position: "absolute",
                  bottom: "-20px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "80%",
                  backgroundColor: "#3cca07",
                  color: "white",
                  padding: "8px",
                  borderRadius: "10px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize:"14px"
  
                }}
              >
                {categoria.nombre}
              </div>
            </div>
            <div
              style={{
                marginTop: "30px",
                textAlign: "center",
                fontSize: "14px",
                color: "#fff",
                fontWeight: "bold",
              }}
            >
              {""}
            </div>
          </div>
      </div>
</div>
            </div>
        ))}


<Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
  <div style={{ padding: "20px", textAlign: "center" }}>
    <h3>Editar Categoría</h3>

    {/* Entrada de imagen (vacía por defecto) */}
    <input
      type="text"
      placeholder="URL de la nueva imagen (opcional)"
      value={editImg}
      onChange={(e) => setEditImg(e.target.value)}
      style={{ display: "block", margin: "10px auto", padding: "5px" }}
    />

    {/* Checkboxes de servicios (solo uno seleccionado a la vez) */}
    <div style={{ textAlign: "left", margin: "10px auto" }}>
      <h4>Selecciona un servicio:</h4>
      {Array.isArray(servicios) &&
        servicios.map((servicio) => (
          <div key={servicio} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <input
              type="checkbox"
              checked={selectedServicio === servicio} // Marca el servicio correcto
              onChange={() => setSelectedServicio(servicio)} // Cambia de servicio
            />
            <label>{servicio}</label>
          </div>
        ))}
    </div>

    {/* Botón solo habilitado si se hace un cambio */}
    <button 
      onClick={guardarEdicionCategoria}
      disabled={editImg.trim() === "" && selectedServicio === ""}
      style={{ marginTop: "10px", padding: "10px 20px", cursor: "pointer" }}
    >
      Guardar
    </button>
  </div>
</Dialog>



    </div>

  </div>
</div>


</div>

    



      </div>

    </div>

  </div>

 
</div>
  </ProteccionAdmin>





    );
  }
  
  export default PantallaPrincipal;
  




























